module.exports = __webpack_public_path__ + "img/CT.Tunnels.Tunnel_Lining.Primary_Lining_Only_(Single_Shell).Reinforced_Concrete.35a27f5a.png";